import React, { useRef, useState } from "react";
import "./index.scss";
import BarInfo from "../../mediaContent/barInfo";
import IconVideo from "../../assets/images/videoIcon.png";
import IconPhoto from "../../assets/images/photoIcon.png";
import Icon3D from "../../assets/images/3dIcon.png";
import Button from "@mui/material/Button";
import { BigPlayButton, ControlBar, LoadingSpinner, Player, PlayToggle, ProgressControl } from "video-react";
import { getTargetAlternateKey } from "../alternateConstruction";
import { useTranslation } from "../../i18n";

const BottomBarInfo = ({
  isOpen,
  infoKey,
  stepId,
  onClose,
  goToStep,
  openPhotoViewer,
  openVideoViewer,
  openVRViewer,
  openMediaLibrary
}) => {
  const {
    _t,
    language
  } = useTranslation();
  const player = useRef(null);
  const selectedItem = BarInfo(language).find(el => el.type === infoKey);

  function generateFixedConstruction() {
    const key = getTargetAlternateKey(stepId);
    goToStep(key, {});
    onClose();
  }

  const [contentType, setContentType] = useState("video");

  function previewVideo(el) {
    openVideoViewer(true, el.video, el.title);
  }

  function previewPhoto(index) {
    openPhotoViewer(true, selectedItem.photo, index);
  }

  function previewVR(el) {
    openVRViewer(true, el.folder, el.xCount, el.yCount);
  }

  if (!selectedItem) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: `bottomBarInfo ${isOpen ? "open" : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "bottomBarInfo-backdrop",
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "bottomBarInfo-contentView"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contentContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contentMedia"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contentMedia-title"
  }, _t("Объясняющее видео")), /*#__PURE__*/React.createElement("div", {
    className: "contentMedia-wrapper"
  }, /*#__PURE__*/React.createElement(Player, {
    ref: player,
    src: selectedItem.preview.video,
    poster: selectedItem.preview.img,
    preload: "auto",
    autoPlay: true,
    loop: true
  }, /*#__PURE__*/React.createElement(ControlBar, {
    disableDefaultControls: true
  }, /*#__PURE__*/React.createElement(PlayToggle, null), /*#__PURE__*/React.createElement(ProgressControl, null)), /*#__PURE__*/React.createElement(BigPlayButton, {
    position: "center"
  }), /*#__PURE__*/React.createElement(LoadingSpinner, null))), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    onClick: () => {
      previewVideo({
        title: selectedItem.title,
        video: selectedItem.preview.video
      });
    }
  }, _t("Открыть на полный экран"))), /*#__PURE__*/React.createElement("div", {
    className: "contentText"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contentText-title"
  }, _t("Описание")), /*#__PURE__*/React.createElement("div", {
    className: "contentText-wrapper",
    dangerouslySetInnerHTML: {
      __html: selectedItem.text
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "actionBtnsRow"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary closeBottomBarInfoBtn",
    onClick: onClose
  }, _t("Закрыть")), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary closeBottomBarInfoBtn",
    onClick: () => {
      openMediaLibrary(true);
    }
  }, _t("Медиатека")), ["PSP_ET_e1_e2_adenty_adentyTop_adentyTopGum", "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomGum", "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothGum", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_fixedProsthetics_suspendedToothSelect_extraCrownsSelect_extraVeneersSelect_compositeRestorations_toothConnections_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseTop_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBottom_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_bugelBase_bugelBaseBoth_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseTop_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBottom_extraCrownsSelect_compositeRestorations_finishStep", "PSP_ET_e1_e2_adenty_partial_decayedTeeth_prostheticsPrepare_prosthesisSelect_removableProsthetics_plasticBase_plasticBaseBoth_extraCrownsSelect_compositeRestorations_finishStep"].includes(stepId) && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary selectBottomBarInfoBtn",
    onClick: generateFixedConstruction
  }, _t("Спроектировать альтернативную конструкцию")))), /*#__PURE__*/React.createElement("div", {
    className: "bottomBarInfo-contentListWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contentMedia-title"
  }, _t("Дополнительный контент")), /*#__PURE__*/React.createElement("div", {
    className: "contentMedia-switchers"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${contentType === "photo" ? "active" : ""}`,
    onClick: () => {
      setContentType("photo");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: IconPhoto,
    alt: ""
  })), /*#__PURE__*/React.createElement("span", null, _t("Фото"))), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${contentType === "video" ? "active" : ""}`,
    onClick: () => {
      setContentType("video");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: IconVideo,
    alt: ""
  })), /*#__PURE__*/React.createElement("span", null, _t("Видео"))), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${contentType === "vr" ? "active" : ""}`,
    onClick: () => {
      setContentType("vr");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: Icon3D,
    alt: ""
  })), /*#__PURE__*/React.createElement("span", null, _t("3D")))), /*#__PURE__*/React.createElement("div", {
    className: "contentMedia-contentList"
  }, contentType === "video" && selectedItem.video && selectedItem.video.map((el, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: `contentMedia-contentList-item ${contentType === "video" ? "videoItem" : ""} `,
    onClick: () => previewVideo(el)
  }, /*#__PURE__*/React.createElement("img", {
    src: el.videoPoster,
    className: "image",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, el.title))), contentType === "photo" && selectedItem.photo && selectedItem.photo.map((el, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "contentMedia-contentList-item",
    onClick: () => previewPhoto(index)
  }, /*#__PURE__*/React.createElement("img", {
    src: el.photo,
    className: "image",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, el.title))), contentType === "vr" && selectedItem.vr && selectedItem.vr.map((el, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "contentMedia-contentList-item",
    onClick: () => previewVR(el)
  }, /*#__PURE__*/React.createElement("img", {
    src: el.preview,
    className: "image",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, el.title))))));
};

export default BottomBarInfo;